var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcGuards({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iconography"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.75 18H8.25V22.5H9.75V18Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 15H6C5.40346 14.9994 4.83155 14.7621 4.40973 14.3403C3.98792 13.9185 3.75066 13.3466 3.75 12.75V4.50005H2.25V12.75C2.25117 13.7443 2.64664 14.6974 3.34964 15.4004C4.05265 16.1034 5.0058 16.4989 6 16.5H16.5C17.0464 16.5025 17.5855 16.6256 18.0787 16.8608L13.5 21.4395L14.5606 22.5L19.2909 17.7697C19.9053 18.4501 20.2468 19.3333 20.25 20.25V22.5H21.75V20.25C21.7485 18.8581 21.1948 17.5237 20.2106 16.5394C19.2264 15.5552 17.8919 15.0016 16.5 15Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7059 3.029L14.4559 1.529C14.3211 1.4905 14.1783 1.4905 14.0434 1.529L8.79345 3.029C8.60647 3.08247 8.44759 3.20653 8.35038 3.37497C8.25317 3.54342 8.22524 3.74305 8.2725 3.9317L9 6.8423V8.25005C9 8.93949 9.1358 9.62218 9.39963 10.2591C9.66347 10.8961 10.0502 11.4749 10.5377 11.9624C11.0252 12.4499 11.604 12.8366 12.2409 13.1004C12.8779 13.3643 13.5606 13.5 14.25 13.5C14.9394 13.5 15.6221 13.3643 16.2591 13.1004C16.896 12.8366 17.4748 12.4499 17.9623 11.9624C18.4498 11.4749 18.8365 10.8961 19.1004 10.2591C19.3642 9.62218 19.5 8.93949 19.5 8.25005V6.8423L20.2275 3.9317C20.2747 3.74297 20.2467 3.54327 20.1494 3.37481C20.0521 3.20635 19.893 3.08235 19.7059 3.029ZM14.25 3.03005L18.5964 4.2719L18.1642 6.00005H15V4.50005H13.5V6.00005H10.3357L9.9036 4.2719L14.25 3.03005ZM14.25 12C13.2558 11.9989 12.3026 11.6034 11.5996 10.9004C10.8966 10.1974 10.5012 9.24426 10.5 8.25005V7.50005H18V8.25005C17.9988 9.24426 17.6034 10.1974 16.9004 10.9004C16.1974 11.6034 15.2442 11.9989 14.25 12Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcGuards);
export default __webpack_public_path__ + "static/media/ic-guards.cafac2cd6d4c798b179fe9ca62daf3a0.svg";
export { ForwardRef as ReactComponent };